import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
} from "@chakra-ui/react";
import "./css/prebooking.css";

const TargetParameterModal = ({
  isOpen,
  onClose,
  onApply,
  onClear,
  setLocation,
  location,
  selectedAudience,
  setSelectedAudience,
}) => {
  // Toggle selection for target audience options
  const handleCheckboxChange = (group, option) => {
    setSelectedAudience((prevState) => {
      const groupSelections = prevState[group];
      if (groupSelections.includes(option)) {
        // Remove option if already selected
        return {
          ...prevState,
          [group]: groupSelections.filter((item) => item !== option),
        };
      } else {
        // Add option if not selected
        return {
          ...prevState,
          [group]: [...groupSelections, option],
        };
      }
    });
  };

  const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      isCentered={!isSmallScreen}
    >
      <ModalOverlay />
      <ModalContent
        className="pre-booking-modal-content"
        
      >
        <ModalHeader>
          <div className="pre-booking-modal-header">
            <h2>Target Parameters</h2>
            <ModalCloseButton className="pre-booking-modal-close-button" />
          </div>
        </ModalHeader>

        <ModalBody className="pre-booking-modal-body">
          {/* Ad Location Section */}
          <div className="pre-booking-input-group">
            <label htmlFor="ad-location" className="pre-booking-input-label">
              Ad Location
            </label>
            <span className="pre-booking-input-description">
              Specify location to show ads
            </span>
            <input
              id="ad-location"
              type="text"
              placeholder="Enter Location"
              className="pre-booking-input-field"
              value={location}
              onChange={(e) => setLocation(e.target.value)}
            />
          </div>

          {/* Target Audience Section */}
          <div className="pre-booking-input-group">
            <label className="pre-booking-input-label">Target Audience</label>
            <div className="pre-booking-audience-options">
              {/* Gender Group */}
              <div className="pre-booking-audience-group">
                <p className="pre-booking-group-title">Gender</p>
                <div className="pre-booking-checkbox-group">
                  <label className="pre-booking-checkbox-label">
                    <input
                      type="checkbox"
                      value="Male"
                      checked={selectedAudience.gender.includes("Male")}
                      onChange={() => handleCheckboxChange("gender", "Male")}
                    />
                    Male
                  </label>
                  <label className="pre-booking-checkbox-label">
                    <input
                      type="checkbox"
                      value="Female"
                      checked={selectedAudience.gender.includes("Female")}
                      onChange={() => handleCheckboxChange("gender", "Female")}
                    />
                    Female
                  </label>
                </div>
              </div>
              {/* Age Group */}
              <div className="pre-booking-audience-group">
                <p className="pre-booking-group-title">Age</p>
                <div className="pre-booking-checkbox-group">
                  <label className="pre-booking-checkbox-label">
                    <input
                      type="checkbox"
                      value="18-30"
                      checked={selectedAudience.age.includes("18-30")}
                      onChange={() => handleCheckboxChange("age", "18-30")}
                    />
                    18-30
                  </label>
                  <label className="pre-booking-checkbox-label">
                    <input
                      type="checkbox"
                      value="31-50"
                      checked={selectedAudience.age.includes("31-50")}
                      onChange={() => handleCheckboxChange("age", "31-50")}
                    />
                    31-50
                  </label>
                  <label className="pre-booking-checkbox-label">
                    <input
                      type="checkbox"
                      value="51+"
                      checked={selectedAudience.age.includes("51+")}
                      onChange={() => handleCheckboxChange("age", "51+")}
                    />
                    51+
                  </label>
                </div>
              </div>
              {/* Income Group */}
              <div className="pre-booking-audience-group">
                <p className="pre-booking-group-title">Income</p>
                <div className="pre-booking-checkbox-group">
                  <label className="pre-booking-checkbox-label">
                    <input
                      type="checkbox"
                      value="High"
                      checked={selectedAudience.income.includes("High")}
                      onChange={() => handleCheckboxChange("income", "High")}
                    />
                    High
                  </label>
                  <label className="pre-booking-checkbox-label">
                    <input
                      type="checkbox"
                      value="Mid"
                      checked={selectedAudience.income.includes("Mid")}
                      onChange={() => handleCheckboxChange("income", "Mid")}
                    />
                    Mid
                  </label>
                  <label className="pre-booking-checkbox-label">
                    <input
                      type="checkbox"
                      value="Low"
                      checked={selectedAudience.income.includes("Low")}
                      onChange={() => handleCheckboxChange("income", "Low")}
                    />
                    Low
                  </label>
                </div>
              </div>
            </div>
          </div>
        </ModalBody>

        <ModalFooter className="pre-booking-modal-footer">
          <button
            className="pre-booking-btn pre-booking-btn-cancel"
            onClick={onClear}
          >
            Clear
          </button>
          <button
            className="pre-booking-btn pre-booking-btn-delete"
            onClick={onApply}
          >
            Apply
          </button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TargetParameterModal;
